import React from 'react'
import { FaRegHandPointRight } from "react-icons/fa";
import Calculator from './Calculator';
import { Rating } from 'react-simple-star-rating';
import { SiTrustpilot } from "react-icons/si";
import Container from 'react-bootstrap/esm/Container';


const Hero = () => {
  return (
    <>
    <div className='ocs2-main-box'>
    <Container>
      <div className='ocs2-main' id='hero'>
        <div className='ocs2-mainHeading'>
          <h1><span className='ocs2-topHeading'>Best Online Course Services for</span><br />
            <span>Academic Success</span></h1>
          <p className='ocs2-topText'>Hiring us makes all the difference as we have professional course helpers who will handle your assignments, projects, and courses <br />
          effectively giving you a successful and brighter academic period.<br/>
          </p>
          <ul>
            <li><FaRegHandPointRight className='ocs2-list-icon' />&nbsp; 100% Plagiarism-Free Content</li>
            <li><FaRegHandPointRight className='ocs2-list-icon' />&nbsp; Hassle-Free and Timely Delivery</li>
            <li><FaRegHandPointRight className='ocs2-list-icon' />&nbsp; Free Revisions</li>
            <li><FaRegHandPointRight className='ocs2-list-icon' />&nbsp; 100% Confidentiality</li>
          </ul>
          <div className='ocs2-banner-capella'>
            <div className='ocs2-banner-capella-path'>
              <span>
                <h3 className='f-path-pointer'>Flex Path</h3>
                <p>Use your experience to complete courses.</p>
              </span>
            </div>
            <div className='ocs2-banner-capella-path'>
              <span>
                <h3 className='f-path-pointer'>Guided Path</h3>
                <p>Enjoy the flexibility to study anywhere.</p>
              </span>
            </div>
          </div>
          <p>Trusted By 15K+ Students & <span className='ocs2-ratingCount'>Rated 4.8/5</span> Based on 9K+ Reviews</p>
          <div className='ocs2-ratting'>
            <div className='ocs2-ratting-provider'>
              <SiTrustpilot className='ocs2-trustpilot-icon' />
              <div>
                <span className='ocs2-ratting-stars'>4.7 <Rating name="half-rating-read" initialValue={5} fillColor='#1f323c' size={20} readonly /></span>
                <p>TrustPilot</p>
              </div>
            </div>
            <div className='ocs2-ratting-provider'>
              <img src='images/favicon.png' alt='' className='ocs2-ratting-favicon' />
              <div>
                <span className='ocs2-ratting-stars'>4.8 <Rating name="half-rating-read" initialValue={5} fillColor='#1f323c' size={20} readonly /></span>
                <p>OnlineCourseServices</p>
              </div>
            </div>
            <div className='ocs2-ratting-provider'>
              <img src='images/sitejabber.png' alt='' className='ocs2-ratting-favicon' />
              <div>
                <span className='ocs2-ratting-stars'>4.9 <Rating name="half-rating-read" initialValue={5} fillColor='#1f323c' size={20} readonly /></span>
                <p>Sitejabber</p>
              </div>
            </div>
          </div>

        </div>
        <div className='ocs2-form'>
          <Calculator />
        </div>
      </div>
      </Container>
      </div>
    </>
  )
}

export default Hero
